<template>
  <div class="page-content">
    <div class="login-logo">
      <img src="../../assets/images/logo-login.png" style="width: 269px;">
    </div>
    <div class="login-content">
      <div class="content-block">
        <div><img src="../../assets/images/login-content.png" style="width: 700px; height: 470px;"></div>
        <div class="login-body">
          <div class="cover-font">欢迎登陆</div>
          <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
              <el-form-item label="" prop="username">
                <el-input v-model="ruleForm.username" @keypress.native.enter="login('ruleForm')" placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input v-model="ruleForm.password" @keypress.native.enter="login('ruleForm')" type="password" placeholder="请输入密码"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="forget">
            <div class="remember-btn"><el-checkbox v-model="checked"></el-checkbox>&nbsp;&nbsp;记住我</div>
            <div class="forget-btn">忘记密码？</div>
          </div>
          <div class="login-btn" @click="login('ruleForm')">
            <el-button type="primary" style="width: 100%;">登录</el-button>
          </div>
          <div class="login-btn" @click="showTips">
            <el-button style="width: 100%;">扫描二维码登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      checked: true,
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = '/';
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/trader/login/doLogin', this.ruleForm)
            .then(res => {
              if (res.code === 200) {
                this.$router.push({ path: '/' });
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    showTips() {
      this.$message.error('二维码登陆修复中');
    }
  }
};
</script>
<style lang="less">
  html, body, #app {
    padding: 0;
    margin: 0;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    width: 100%;
    height: 100%;
  }
  .login-logo {
    position: fixed;
    left: 40px;
    top: 40px;
  }
  .page-content {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: relative;
    background-image: url(../../assets/images/login-bg.png);
    background-repeat: no-repeat;
    .login-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .content-block {
        width: 1140px;
        height: 470px;
        position: relative;
        display: flex;
        .login-body {
          width: 350px;
          height: 400px;
          background: #fff;
          padding: 35px 45px;
          .cover-font {
            color: #333;
            font-size: 32px;
            font-weight: bolder;
          }
          .form, .forget {
            margin-top: 60px;
          }
          .forget {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            .forget-btn {
              color: #00a1d6;
            }
            .forget-btn:hover {
              cursor: pointer;
              color: #F35C8F;
            }
          }
          .login-btn {
            margin-top: 15px;
          }
        }
      }
    }
  }
  .el-card__body {
    padding: 20px;
  }
  .el-input-group__append {

  }
</style>
